// import React from 'react';
// import { CalendarIcon, MapPinIcon } from 'lucide-react';

// const JobEducationSection = ({ educationData }: any) => {
//   const parseEducation = (educationString: any) => {
//     try {
//       return JSON.parse(educationString);
//     } catch (e) {
//       console.error('Error parsing education data:', e);
//       return { education_details: [] };
//     }
//   };

//   const formatDate = (month: any, year: any) => {
//     if (!month || !year) return '';
//     return `${month}/${year}`;
//   };

//   const education = parseEducation(educationData);

//   return (
//     <div className="space-y-6">
//       {education.education_details?.map((edu: any, index: any) => (
//         <div key={index} className="flex gap-4 items-start">
//           <div className="w-12 h-12 flex-shrink-0">
//             <div className="w-full h-full bg-gray-300 rounded-lg flex items-center justify-center">
//               {edu?.course?.charAt(0)}
//             </div>
//           </div>

//           <div className="flex-1">
//             <h3 className="text-[13px] text-[#374151] font-normal leading-5">{edu.course}</h3>
//             <p className="font-normal text-dark-black-200 text-[12px] wg-antialiased leading-4">{edu.university}</p>

//             <div className="mt-0 flex items-center gap-4 text-sm text-gray-500">
//               <div className="flex items-center gap-1">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width={24}
//                   height={24}
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth={2}
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="icon icon-tabler icons-tabler-outline icon-tabler-calendar text-[#808080] w-[0.9rem] h-[0.9rem]"
//                 >
//                   <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                   <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
//                   <path d="M16 3v4" />
//                   <path d="M8 3v4" />
//                   <path d="M4 11h16" />
//                   <path d="M11 15h1" />
//                   <path d="M12 15v3" />
//                 </svg>
//                 <span className='font-normal text-dark-black-200 text-[12px]'>{edu.start_date} - {edu.end_date}</span>
//               </div>

//               {edu.location && (
//                 <div className="flex items-center gap-1">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width={24}
//                     height={24}
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     className="icon icon-tabler icons-tabler-outline icon-tabler-map-pin w-[0.9rem] h-[0.9rem]"
//                   >
//                     <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                     <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
//                     <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
//                   </svg>

//                   <span className='font-normal text-dark-black-200 text-[12px]'>{edu.location}</span>
//                 </div>
//               )}
//             </div>

//             {edu.branch && (
//               <p className="mt-1 font-normal text-dark-black-200 text-[12px]">
//                 Specialization: {edu?.branch}
//               </p>
//             )}

//             {edu.grade && (
//               <p className="mt-1 font-normal text-dark-black-200 text-[12px]">
//                 Grade: {edu.grade}
//               </p>
//             )}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default JobEducationSection;
//@ts-nocheck
import React, { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ChevronDownIcon, CrossIcon } from "../icons/Icons";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchApplicationByDetails,
  UpdateJobApplicationByListForApplication,
} from "../../features/ApplicationData/ApplicationDataSlice";
import JobEduLocationModal from "./JobEduLocationModal";
import { toast } from "sonner";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  Switch,
  Transition,
} from "@headlessui/react";
import { getAllByAltText, getByLabelText } from "@testing-library/react";
import { getColorForLabel } from "../../utils/colorUtils";

const CustomDropdown = ({
  label,
  value,
  onChange,
  options,
  name,
  placeholder = "Select...",
}) => {
  const selectedOption = options.find((opt) => opt.value === value);

  const handleChange = (newValue) => {
    // Simulate an event object that matches the expected structure
    onChange({
      target: {
        name: name,
        value: newValue,
      },
    });
  };

  return (
    <div className="grid gap-[6px]">
      {label && (
        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
          {label}
        </label>
      )}
      <Listbox value={value} onChange={handleChange}>
        <div className="relative">
          <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-[5px] pl-3 pr-10 text-left border border-gray-200 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2">
            <span
              className={`block truncate text-[14px] ${!selectedOption ? "text-gray-400" : "text-gray-900"}`}
            >
              {selectedOption ? selectedOption.label : placeholder}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={React.Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute overflow-auto h-[150px] z-10 mt-[9px] left-[0px] bg-white max-w-[100%] min-w-[100%] w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
              {options.map((option) => (
                <Listbox.Option
                  key={option.value}
                  value={option.value}
                  className={({ active, selected }) =>
                    `relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 ${active ? "bg-gray-200 text-[#1d2025]" : "text-gray-900"}`
                  }
                >
                  {({ selected }) => (
                    <span
                      className={`block truncate text-[14px] ${selected ? "font-medium" : "font-normal"}`}
                    >
                      {option.label}
                    </span>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

const JobEducationSection = ({
  educationData,
  onUpdate,
  setapplicationDetails,
  isConductReview,
  applicationIdByParent,
}: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEducation, setSelectedEducation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [editForm, setEditForm] = useState({
    course: "",
    university: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    location: "",
    branch: "",
    grade: "",
    description: "",
  });
  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const dispatch = useAppDispatch();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const locations = useAppSelector((state) => state.location.locationDetails);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [workEducationData, setWorkEducationData] = useState(educationData);
  const [openDeleteModalExp, setOpenDeleteModalExp] = useState(false);
  const [deleteLoadingExp, setDeleteLoadingExp] = useState(false);

  const parseEducation = (educationString: any) => {
    try {
      const parsedData = JSON.parse(educationString);
      // Ensure education_details is an array and filter out null values
      parsedData.education_details =
        parsedData.education_details?.filter((edu) => edu !== null) || [];
      return parsedData;
    } catch (e) {
      console.error("Error parsing education data:", e);
      return { education_details: [] };
    }
  };
  // Split the date string to extract month and year
  const splitDate = (dateString) => {
    if (!dateString) return { month: "", year: "" };

    // Check if the format is already separated
    if (typeof dateString === "object" && dateString.month && dateString.year) {
      return dateString;
    }

    // Try to parse as a string
    const parts = dateString.toString().split(" ");
    if (parts.length === 2) {
      // Convert month name to number
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthIndex = monthNames.indexOf(parts[0]);
      const month =
        monthIndex >= 0 ? (monthIndex + 1).toString().padStart(2, "0") : "";
      return { month, year: parts[1] };
    }

    return { month: "", year: "" };
  };

  const education = parseEducation(educationData);

  const handleEditClick = (edu, index) => {
    if (isConductReview) return;
    // Better extraction of start date components
    let startMonth = "",
      startYear = "";
    if (edu.start_month) {
      startMonth = edu.start_month;
    } else if (edu.start_date) {
      if (typeof edu.start_date === "object") {
        startMonth = edu.start_date.month || "";
        startYear = edu.start_date.year || "";
      } else {
        const startParts = splitDate(edu.start_date);
        startMonth = startParts.month || "";
        startYear = startParts.year || "";
      }
    }
    startYear = startYear || edu.start_year || "";

    // Better extraction of end date components
    let endMonth = "",
      endYear = "";
    if (edu.end_month) {
      endMonth = edu.end_month;
    } else if (edu.end_date) {
      if (typeof edu.end_date === "object") {
        endMonth = edu.end_date.month || "";
        endYear = edu.end_date.year || "";
      } else {
        const endParts = splitDate(edu.end_date);
        endMonth = endParts.month || "";
        endYear = endParts.year || "";
      }
    }
    endYear = endYear || edu.end_year || "";

    setSelectedEducation(edu);
    setSelectedIndex(index);
    setEditForm({
      course: edu.course || "",
      university: edu.university || "",
      start_month: startMonth,
      start_year: startYear,
      end_month: endMonth,
      end_year: endYear,
      location: edu.location || "",
      branch: edu.branch || "",
      grade: edu.grade || "",
      description: edu.description || "",
    });
    setIsModalOpen(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      // Create a copy of the original education object
      const updatedEducation = { ...education };

      // Create updated education details array
      const updatedEducationDetails = [...education.education_details];

      // Format the dates properly
      const start_date = {
        month: editForm.start_month,
        year: editForm.start_year,
      };

      const end_date = {
        month: editForm.end_month,
        year: editForm.end_year,
      };

      // Update the specific education entry
      updatedEducationDetails[selectedIndex] = {
        ...selectedEducation,
        ...editForm,
        // Maintain any additional fields from the original entry
        course: editForm.course,
        university: editForm.university,
        start_date: editForm.start_date,
        end_date: editForm.end_date,
        location: editForm.location,
        branch: editForm.branch,
        grade: editForm.grade,
        description: editForm.description,
      };

      // Update the education_details in the copied object
      updatedEducation.education_details = updatedEducationDetails;
      const payload = {
        baseId,
        applicationId: applicationId ? applicationId : applicationIdByParent,
        app_education: JSON.stringify(updatedEducation),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response) {
        toast.success("Education updated successfully");
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId
              ? applicationId
              : applicationIdByParent,
          }),
        ).unwrap();
        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        if (onUpdate) {
          onUpdate(updatedEducation);
        }
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to update education:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLocationChange = (item) => {
    // Update the selected country state
    setSelectedCountry(item);

    // Update the location field in the editForm state
    setEditForm((prev) => ({
      ...prev,
      location: item.locationName, // Assuming the location object has a 'locationName' property
    }));
  };

  // Month options with text labels
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = Array.from({ length: 30 }, (_, i) => {
    const year = (2025 - i).toString();
    return { value: year, label: year };
  });

  // Convert numeric month to text representation
  const getMonthName = (monthNumber) => {
    if (!monthNumber) return "";
    const monthIndex = parseInt(monthNumber, 10) - 1;
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[monthIndex] || "";
  };

  // Format month and year for display
  const formatMonthYear = (month, year) => {
    if (!month || !year) return "";
    const monthName = getMonthName(month);
    return `${monthName} ${year}`;
  };

  const formatDate = (month, year) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthIndex = parseInt(month, 10) - 1;
    return monthNames[monthIndex] ? `${monthNames[monthIndex]} ${year}` : year;
  };

  const formatDateRange = (edu) => {
    // Extract start date components
    const startMonthValue =
      edu.start_month ||
      (edu.start_date && typeof edu.start_date === "object"
        ? edu.start_date.month
        : "");
    const startYearValue =
      edu.start_year ||
      (edu.start_date && typeof edu.start_date === "object"
        ? edu.start_date.year
        : "");
    const startMonthName = getMonthName(startMonthValue);
    const formattedStartDate =
      startMonthName && startYearValue
        ? `${startMonthName} ${startYearValue}`
        : "";

    // Extract end date components
    const endMonthValue =
      edu.end_month ||
      (edu.end_date && typeof edu.end_date === "object"
        ? edu.end_date.month
        : "");
    const endYearValue =
      edu.end_year ||
      (edu.end_date && typeof edu.end_date === "object"
        ? edu.end_date.year
        : "");
    const endMonthName = getMonthName(endMonthValue);
    const formattedEndDate =
      endMonthName && endYearValue
        ? `${endMonthName} ${endYearValue}`
        : endYearValue || "";

    return formattedStartDate && formattedEndDate
      ? `${formattedStartDate} - ${formattedEndDate}`
      : "";
  };

  const handleDeleteClick = (edu, index) => {
    setSelectedIndex(index); // Store the index to be deleted
    setOpenDeleteModalExp(true); // Open the confirmation modal
  };

  // Function to handle cancel button in delete modal
  const handleCloseModal = () => {
    setOpenDeleteModalExp(false);
    setSelectedIndex(null); // Clear the selected index
  };

  const handleDeleteConfirm = async () => {
    if (selectedIndex === null) return;
    setDeleteLoadingExp(true);
    try {
      const workEducationData =
        typeof educationData === "string"
          ? JSON.parse(educationData)
          : educationData;

      const filteredArray = workEducationData.education_details.filter(
        (_, index) => index !== selectedIndex,
      );

      const newWorkEducation = {
        education_details: filteredArray,
      };

      filteredArray.forEach((exp, idx) => {
        newWorkEducation[idx.toString()] = exp;
      });

      if (onUpdate) {
        onUpdate(newWorkEducation);
      }

      const payload = {
        baseId,
        applicationId: applicationId ? applicationId : applicationIdByParent,
        app_education: JSON.stringify(newWorkEducation),
      };

      // Call the API
      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Education deleted successfully");
        setIsModalOpen(false);

        // Fetch updated application details
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId
              ? applicationId
              : applicationIdByParent,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }

        // Close the modal
        setOpenDeleteModalExp(false);
        setSelectedIndex(null);
      }
    } catch (error) {
      toast.error("Failed to delete education. Please try again.");
    } finally {
      setDeleteLoadingExp(false);
    }
  };

  return (
    <>
      <div className="space-y-2 mx-[-12px]">
        {education.education_details?.map((edu, index) => {
          const formattedDateRange = formatDateRange(edu);
          if (!edu) return null;
          return (
            <div
              key={index}
              className="flex gap-4 items-start hover:bg-gray-50 p-3 rounded-lg cursor-pointer transition-colors group"
              onClick={() => handleEditClick(edu, index)}
            >
              <div className="w-9 h-9 flex-shrink-0">
                <div
                  className="w-full h-full rounded-lg flex items-center justify-center text-white font-medium"
                  style={{
                    backgroundColor: getColorForLabel(edu?.course || ""),
                  }}
                >
                  {edu?.course?.charAt(0)}
                </div>
              </div>

              <div className="flex-1">
                {edu?.course && (
                  <h3 className="text-[14px] text-[#374151] font-medium leading-5">
                    {edu?.course}
                  </h3>
                )}
                {edu?.university && (
                  <p className="font-normal text-[#374151] text-[13px] wg-antialiased leading-5">
                    {edu?.university}
                  </p>
                )}

                {formattedDateRange && (
                  <div className="mt-0 flex items-center gap-4 text-gray-500 leading-5">
                    <span className="font-normal text-dark-black-200 text-[13px] leading-5">
                      {formattedDateRange}
                    </span>
                  </div>
                )}

                <div className="flex items-center">
                  {edu?.branch && (
                    <p className="mt-0 text-dark-black-200 text-[13px] font-normal leading-5">
                      {/* Specialization:  */}
                      <span className="text-dark-black-200 leading-5">
                        {edu?.branch}
                      </span>
                    </p>
                  )}

                  {edu?.branch && (
                    <p className="mt-0 text-dark-black-200 font-normaltext-[13px] leading-5 flex items-center gap-x-[6px]">
                      <span className="h-[3px] w-[3px] bg-gray-400 rounded-full block mx-[6px]"></span>
                    </p>
                  )}

                  {edu?.grade && (
                    <p className="mt-0 text-dark-black-200 font-normaltext-[13px] leading-5 flex items-center gap-x-[6px]">
                      {/* <span className='h-[3px] w-[3px] bg-gray-400 rounded-full block ml-[6px]'></span> */}
                      <span className="ml-0">
                        Grade:{" "}
                        <span className="text-dark-black-200  leading-5">
                          {edu?.grade}
                        </span>
                      </span>
                    </p>
                  )}
                </div>

                {edu?.location && (
                  <div className="flex items-center gap-1 leading-5">
                    <span className="font-normal text-dark-black-200 text-[13px] leading-5">
                      {edu?.location}
                    </span>
                  </div>
                )}
                {edu?.description && (
                  <div className="flex items-center gap-[6px]">
                    <span className="font-normal text-[#374151] text-[13px] wg-antialiased leading-5">
                      {edu?.description}
                    </span>
                  </div>
                )}
              </div>

              {/* Edit Button - Visible on Hover */}
              {!isConductReview && (
                <div className="flex items-center gap-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent the parent onClick from firing
                      handleEditClick(edu, index);
                    }}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-edit w-[0.9rem] h-[0.9rem]"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                      <path d="M16 5l3 3" />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          );
        })}

        <Dialog
          open={isModalOpen}
          onClose={setIsModalOpen}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/35 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl
               transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300
                data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <h3 className="text-base font-semibold leading-6 text-gray-900">
                  Edit Education Details
                </h3>
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon aria-hidden="true" className="size-6" />
                  </button>
                </div>

                <div className="grid gap-4 py-4 mt-1">
                  <div className="grid gap-[6px]">
                    <label
                      htmlFor="course"
                      className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                    >
                      Course
                    </label>
                    <input
                      id="course"
                      name="course"
                      value={editForm?.course}
                      onChange={handleInputChange}
                      className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                    />
                  </div>
                  <div className="grid gap-[6px]">
                    <label
                      htmlFor="course"
                      className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                    >
                      University
                    </label>
                    <input
                      id="university"
                      name="university"
                      value={editForm?.university}
                      onChange={handleInputChange}
                      className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        Start Date
                      </label>
                      <div className="grid grid-cols-2 gap-2">
                        <CustomDropdown
                          value={editForm.start_month}
                          onChange={handleInputChange}
                          options={months}
                          name="start_month"
                          placeholder="Month"
                        />
                        <CustomDropdown
                          value={editForm.start_year}
                          onChange={handleInputChange}
                          options={years}
                          name="start_year"
                          placeholder="Year"
                        />
                      </div>
                    </div>
                    <div className="grid gap-[6px]">
                      <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                        End Date
                      </label>
                      <div className="grid grid-cols-2 gap-2">
                        <CustomDropdown
                          value={editForm.end_month}
                          onChange={handleInputChange}
                          options={months}
                          name="end_month"
                          placeholder="Month"
                        />
                        <CustomDropdown
                          value={editForm.end_year}
                          onChange={handleInputChange}
                          options={years}
                          name="end_year"
                          placeholder="Year"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-[6px]">
                    <label
                      htmlFor="course"
                      className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                    >
                      Location
                    </label>
                    <JobEduLocationModal
                      items={locations}
                      buttonText="Search by city, state, or country"
                      onChange={handleLocationChange}
                      selectedItem={selectedCountry}
                      isLoading={loadingLocation}
                    />
                    {/* <input
                    id="location"
                    name="location"
                    value={editForm?.location}
                    onChange={handleInputChange}
                    className='flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]'
                  /> */}
                  </div>
                  <div className="grid gap-[6px]">
                    <label
                      htmlFor="course"
                      className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                    >
                      Specialization
                    </label>
                    <input
                      id="branch"
                      name="branch"
                      value={editForm?.branch}
                      onChange={handleInputChange}
                      className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                    duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                   dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                    />
                  </div>
                  <div className="grid gap-[6px]">
                    <label
                      htmlFor="grade"
                      className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                    >
                      Grade
                    </label>
                    <input
                      id="grade"
                      name="grade"
                      type="text"
                      value={editForm.grade}
                      onChange={handleInputChange}
                      className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors
                     duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 
                    dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                    />
                  </div>
                  <div className="grid gap-[6px]">
                    <label
                      htmlFor="description"
                      className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                    >
                      Description
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      rows={4}
                      value={editForm.description}
                      onChange={handleInputChange}
                      className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    />
                  </div>
                </div>
                <div className="flex justify-between gap-4 mt-5">
                  <div className="flex items-center gap-4">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent the parent onClick from firing
                        handleDeleteClick(selectedEducation, selectedIndex); // Pass the entire experience object
                      }}
                      className="text-gray-500 hover:text-gray-900"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-trash w-[1rem] h-[1rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 7l16 0" />
                        <path d="M10 11l0 6" />
                        <path d="M14 11l0 6" />
                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                      </svg>
                    </button>
                  </div>
                  <div className="flex justify-end gap-4">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isLoading && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      </div>

      {openDeleteModalExp && (
        <Dialog
          open={true}
          onClose={handleCloseModal}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon />
                  </button>
                </div>
                <div className="flex flex-col gay-y-4">
                  <span className="leading-6 text-sm text-gray-500">
                    Do you want to sure delete this Education?
                  </span>
                </div>
                <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="items-center px-[14px] py-1 text-[13px] font-medium h-[32px] inline-flex leading-6 w-fit justify-center rounded-md bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleDeleteConfirm()}
                    type="button"
                    className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 "
                  >
                    {deleteLoadingExp ? (
                      <div className="flex items-center gap-[6px]">
                        Delete
                        <div className="simple-spinner">
                          <span></span>
                        </div>
                      </div>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default JobEducationSection;
